import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Welcome back!");
            navigate("/");
        } catch (err) {
            const msg = formatApiError(err);
            toast.error(msg);
            if (err?.response?.status === 403 && /suspended/i.test(msg || "")) {
                setTimeout(() => navigate("/appeal"), 1200);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="max-w-md mx-auto px-4 py-12">
            <div className="bg-white brut-static rounded-xl p-6 sm:p-8">
                <h1 className="display text-3xl font-black mb-1">Welcome back.</h1>
                <p className="text-sm text-[#4A4A4A] mb-6">Log in to rate & post.</p>
                <form onSubmit={submit} className="space-y-4" data-testid="login-form">
                    <div>
                        <label className="text-xs font-bold uppercase tracking-wide">Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full mt-1 px-4 py-3 rounded-lg brut-inset bg-white font-medium focus:outline-none focus:shadow-[3px_3px_0px_#0A0A0A]"
                            data-testid="login-email"
                        />
                    </div>
                    <div>
                        <label className="text-xs font-bold uppercase tracking-wide">Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full mt-1 px-4 py-3 rounded-lg brut-inset bg-white font-medium focus:outline-none focus:shadow-[3px_3px_0px_#0A0A0A]"
                            data-testid="login-password"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full px-4 py-3 rounded-lg brut bg-[#0A0A0A] text-white font-bold disabled:opacity-50"
                        data-testid="login-submit"
                    >
                        {loading ? "Logging in…" : "Log in"}
                    </button>
                </form>
                <p className="text-sm mt-5 text-center font-medium">
                    New here?{" "}
                    <Link to="/register" className="font-bold underline" data-testid="login-to-register">
                        Create an account
                    </Link>
                </p>
            </div>
        </main>
    );
}
